import { Injectable } from '@angular/core';
import { SettingsService } from '@barthauer/abc/core';
import { LoginSettingsService, ProfileSettingsService } from '@barthauer/abc/core/authentication';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from '@barthauer/abc/core/data';
import { IMapFrameSettings, MapFrameSetting, MapFrameSettings } from '../models/map-frame-settings.model';

@Injectable()
export class MapFrameSettingsService extends SettingsService<IMapFrameSettings, MapFrameSettings, MapFrameSetting> {
  constructor(
    abcConfigService: AbcConfigService,
    data: DataService,
    loginSettingsService: LoginSettingsService,
    profileSettingsService: ProfileSettingsService
  ) {
    super(
      abcConfigService,
      data,
      loginSettingsService,
      profileSettingsService,
      'MapFrameSettings',
      MapFrameSettings,
      MapFrameSetting
    );
  }

  async createStorage(setting: MapFrameSetting): Promise<import("libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid").IStorage> {
    return {
      setItem: (key, value) => this.setObjectSetting(setting, key, value),
      getItem: (key) => this.getObjectSetting(setting, key)
    }
  }
}
